"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressCircle;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
function ProgressCircle(props) {
  const {
    size = 'small',
    determinate,
    value,
    renderPercentText,
    hideValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "circle-container"
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    variant: "determinate",
    value: 100,
    className: "circle-track circle-track--".concat(size)
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "label-container"
  }, value && !hideValue && /*#__PURE__*/_react.default.createElement("p", {
    className: "progress-circle-label--".concat(size)
  }, renderPercentText(Math.round(value)))), /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    value: value,
    variant: determinate ? 'determinate' : 'indeterminate',
    className: "circle-fill circle-track--".concat(size)
  }));
}